import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function AddUserForm(props) {
  const { showError, name, phone,password ,confirmPassword, email } = props;

  return (
      <Dialog 
      open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Add User</DialogTitle>
        <DialogContent>
          
        <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            type="text"
            fullWidth
            onChange={props.onChange}
            value={props.name}
            error={showError && !name}

          />
          <TextField
            autoFocus
            margin="dense"
            id="email"
            label="Email"
            type="text"
            fullWidth
            onChange={props.onChange}
            value={props.email}
            error={showError && !email}

          />
          <TextField
            autoFocus
            margin="dense"
            id="phone"
            label="Contact Number"
            type="phone"
            fullWidth
            onChange={props.onChange}
            value={props.phone}
            error={showError && !phone}

          />
            <TextField
                autoFocus
                margin="dense"
                id="password"
                label="Password"
                type="phone"
                fullWidth
                onChange={props.onChange}
                value={props.password}
                error={showError && !password}

            />
            <TextField
                autoFocus
                margin="dense"
                id="confirm-password"
                label="Confirm Password"
                type="password"
                fullWidth
                onChange={props.onChange}
                value={props.confirmPassword}
                error={(showError && !confirmPassword) || (showError && confirmPassword !== password)}

            />

        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={props.addUser} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>
  );
}
